var _objectSpread = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: ["icon", classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 1024 1024",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "200",
        "height": "200"
      }, attrs)
    }, rest), children.concat([_c('defs'), _c('path', {
      attrs: {
        "d": "M826.24 420.821a26.923 26.923 0 010 53.803h-74.88v48h74.88a26.88 26.88 0 110 53.717H724.437a26.923 26.923 0 01-26.752-26.837V345.941c0-14.72 12.032-26.88 26.88-26.88h101.803a26.88 26.88 0 01-.128 53.76h-74.88v48h74.88zM661.76 549.504a26.88 26.88 0 01-26.923 26.752 26.368 26.368 0 01-21.76-10.667L508.843 424.064v125.44a26.88 26.88 0 01-53.632 0V345.941a26.752 26.752 0 0126.624-26.794c8.32 0 16 4.437 21.12 10.837L608 472.064V345.941c0-14.72 12.032-26.88 26.88-26.88 14.72 0 26.88 12.16 26.88 26.88v203.563zm-244.95 0a26.965 26.965 0 01-26.922 26.837 26.923 26.923 0 01-26.752-26.837V345.941c0-14.72 12.032-26.88 26.88-26.88 14.763 0 26.795 12.16 26.795 26.88v203.563zm-105.215 26.837H209.792a27.05 27.05 0 01-26.88-26.837V345.941c0-14.72 12.16-26.88 26.88-26.88 14.848 0 26.88 12.16 26.88 26.88v176.683h74.923a26.88 26.88 0 010 53.717M1024 440.064c0-229.163-229.76-415.659-512-415.659S0 210.901 0 440.064c0 205.27 182.187 377.259 428.16 409.941 16.683 3.499 39.381 11.008 45.141 25.174 5.12 12.842 3.371 32.682 1.622 46.08l-6.998 43.52c-1.92 12.842-10.24 50.602 44.758 27.52 55.082-22.998 295.082-173.995 402.602-297.6C988.843 614.1 1024 531.54 1024 440.064"
      }
    })]));
  }
};